(function () {
  const ZIP_PREFIX_STATE = [
    [995, 999, 'AK'], [350, 369, 'AL'], [716, 729, 'AR'], [850, 865, 'AZ'],
    [900, 961, 'CA'], [800, 816, 'CO'], [60, 69, 'CT'], [200, 205, 'DC'],
    [197, 199, 'DE'], [320, 349, 'FL'], [300, 319, 'GA'], [967, 968, 'HI'],
    [500, 528, 'IA'], [832, 838, 'ID'], [600, 629, 'IL'], [460, 479, 'IN'],
    [660, 679, 'KS'], [400, 427, 'KY'], [700, 714, 'LA'], [10, 27, 'MA'],
    [206, 219, 'MD'], [39, 49, 'ME'], [480, 499, 'MI'], [550, 567, 'MN'],
    [630, 658, 'MO'], [386, 397, 'MS'], [590, 599, 'MT'], [270, 289, 'NC'],
    [580, 588, 'ND'], [680, 693, 'NE'], [30, 38, 'NH'], [70, 89, 'NJ'],
    [870, 884, 'NM'], [890, 898, 'NV'], [100, 149, 'NY'], [430, 459, 'OH'],
    [730, 749, 'OK'], [970, 979, 'OR'], [150, 196, 'PA'], [28, 29, 'RI'],
    [290, 299, 'SC'], [570, 577, 'SD'], [370, 385, 'TN'], [750, 799, 'TX'],
    [840, 847, 'UT'], [201, 246, 'VA'], [50, 59, 'VT'], [980, 994, 'WA'],
    [530, 549, 'WI'], [247, 268, 'WV'], [820, 831, 'WY']
  ];

  function zipToState(zip) {
    const cleanZip = String(zip || '').replace(/\D/g, '').slice(0, 5);
    if (cleanZip.length < 3) return null;

    const prefix = Number(cleanZip.slice(0, 3));

    const match = ZIP_PREFIX_STATE.find(([start, end]) => {
      return prefix >= start && prefix <= end;
    });

    return match ? match[2] : null;
  }

function dateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getClosedWeekdays(popover) {
  return String(popover?.dataset.closedWeekdays || '0,6')
    .split(',')
    .map(day => Number(day.trim()))
    .filter(day => !Number.isNaN(day));
}

function getClosedDates(popover) {
  return String(popover?.dataset.closedDates || '')
    .split(/\n|,/)
    .map(date => date.trim())
    .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date));
}

function isClosedDate(date, popover) {
  return (
    getClosedWeekdays(popover).includes(date.getDay()) ||
    getClosedDates(popover).includes(dateKey(date))
  );
}

function getCutoffForDate(date, popover) {
  const day = date.getDay();

  const cutoffs = {
    1: popover?.dataset.cutoffMonday || '14:00',
    2: popover?.dataset.cutoffTuesday || '14:00',
    3: popover?.dataset.cutoffWednesday || '14:00',
    4: popover?.dataset.cutoffThursday || '14:00',
    5: popover?.dataset.cutoffFriday || '12:00'
  };

  return cutoffs[day] || '';
}

function getNextShipDate(date, popover) {
  const result = new Date(date);

  while (isClosedDate(result, popover) || !getCutoffForDate(result, popover)) {
    result.setDate(result.getDate() + 1);
  }

  return result;
}

function getShipDate(popover) {
  const now = new Date();
  const today = new Date(now);

  if (isClosedDate(today, popover)) {
    const next = new Date(today);
    next.setDate(next.getDate() + 1);
    return getNextShipDate(next, popover);
  }

  const cutoff = getCutoffForDate(today, popover);

  if (!cutoff) {
    const next = new Date(today);
    next.setDate(next.getDate() + 1);
    return getNextShipDate(next, popover);
  }

  const [hour, minute] = cutoff.split(':').map(Number);
  const cutoffDate = new Date(today);
  cutoffDate.setHours(hour, minute || 0, 0, 0);

if (now >= cutoffDate) {
    const next = new Date(today);
    next.setDate(next.getDate() + 1);
    return getNextShipDate(next, popover);
  }

  return today;
}
function getShippingStatus(popover) {
  const now = new Date();
  const today = new Date(now);

  if (getClosedDates(popover).includes(dateKey(today))) {
    return 'holiday';
  }

  if (getClosedWeekdays(popover).includes(today.getDay())) {
    return 'closed_day';
  }

  const cutoff = getCutoffForDate(today, popover);

  if (cutoff) {
    const [hour, minute] = cutoff.split(':').map(Number);

    const cutoffDate = new Date(today);
    cutoffDate.setHours(hour, minute || 0, 0, 0);

    if (now >= cutoffDate) {
      return 'after_cutoff';
    }
  }

  return 'shipping_today';
}
function addBusinessDays(date, days, popover) {
  const result = new Date(date);
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);

    if (!isClosedDate(result, popover)) {
      added += 1;
    }
  }

  return result;
}

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }

  function parseZones(popover) {
    try {
      return JSON.parse(popover.dataset.zonesJson || '[]');
    } catch (error) {
      console.warn('Delivery zones JSON is invalid', error);
      return [];
    }
  }

  function findZoneByState(zones, state) {
    if (!state) return null;

    return zones.find(zone => {
      return zone.states
        .split(',')
        .map(item => item.trim().toUpperCase())
        .includes(state.toUpperCase());
    });
  }

  function renderEstimate(popover, zone) {
    const results = popover.querySelector('[data-delivery-results]');
    if (!results) return;

    if (!zone) {
      results.innerHTML = `
        <div class="custom-delivery-method">
          <div>
            <div class="custom-delivery-method__title">Delivery estimate unavailable</div>
            <div class="text-sm">Enter a valid ZIP code or select a supported state.</div>
          </div>
        </div>
      `;
      results.hidden = false;
      return;
    }

const shipDate = getShipDate(popover);

const groundStart = addBusinessDays(shipDate, Number(zone.ground_min || 1), popover);
const groundEnd = addBusinessDays(shipDate, Number(zone.ground_max || zone.ground_min || 1), popover);
const oneDay = addBusinessDays(shipDate, Number(zone.one_day || 1), popover);
const twoDay = addBusinessDays(shipDate, Number(zone.two_day || 2), popover);

      results.innerHTML = `
        <div class="custom-delivery-method">
          <div>
            <div class="custom-delivery-method__title">Free Ground Shipping</div>
            <div class="text-sm">Estimated delivery</div>
          </div>
          <div class="custom-delivery-method__date">
            ${formatDate(groundStart)} – ${formatDate(groundEnd)}
          </div>
        </div>

      <div class="custom-delivery-method">
        <div>
          <div class="custom-delivery-method__title">1-Day</div>
          <div class="text-sm">Estimated delivery</div>
        </div>
        <div class="custom-delivery-method__date">
          ${formatDate(oneDay)}
        </div>
      </div>

      <div class="custom-delivery-method">
        <div>
          <div class="custom-delivery-method__title">2-Day</div>
          <div class="text-sm">Estimated delivery</div>
        </div>
        <div class="custom-delivery-method__date">
          ${formatDate(twoDay)}
        </div>
      </div>
    `;

    results.hidden = false;
  }

  function estimateByState(popover, state) {
    const zones = parseZones(popover);
    const zone = findZoneByState(zones, state);
    renderEstimate(popover, zone);
  }

function updateCountdown() {
  const messageEls = document.querySelectorAll('[data-delivery-message]');

  messageEls.forEach(message => {
    const deliveryContainer = message.closest(
      '.custom-buy-box, .mkcustom-mobile-buy-box, .mkcustom-cart-delivery'
    );

    const popover = deliveryContainer?.querySelector(
      '[data-delivery-popover]'
    );

    const shipDate = getShipDate(popover);

    const clockIcon = deliveryContainer?.querySelector(
      '[data-delivery-clock-icon]'
    );

    const truckIcon = deliveryContainer?.querySelector(
      '[data-delivery-truck-icon]'
    );

    /* ----------------------------------------------------------
   Cart Summary - Free Shipping State
   Use existing cart free-shipping notice as source of truth.
---------------------------------------------------------- */

const estimator = message.closest(
  '.mkcustom-delivery-estimator'
);

const isCartEstimator =
  estimator?.classList.contains(
    'mkcustom-delivery-estimator--cart'
  );

const cartFreeShippingUnlocked =
  isCartEstimator &&
  document.querySelector(
    '.mkcustom-cart-page .free-shipping-container--unlocked'
  ) !== null;

const cartFreeShippingHeading =
  cartFreeShippingUnlocked
    ? '<strong class="custom-buy-box__shipping-free-copy">Free Ground Shipping</strong> '
    : '';

if (dateKey(shipDate) !== dateKey(new Date())) {
  if (clockIcon) clockIcon.hidden = true;
  if (truckIcon) truckIcon.hidden = false;

  const status = getShippingStatus(popover);

  if (status === 'holiday') {
    message.innerHTML =
      'Our warehouse is closed for the holiday. <strong class="custom-buy-box__delivery-countdown">Orders ship the next business day.</strong>';
  } else if (status === 'closed_day') {
    message.innerHTML =
      '<strong class="custom-buy-box__delivery-countdown">Weekend processing.</strong> Orders ship the next business day.';
  } else if (status === 'after_cutoff') {
    message.innerHTML =
      cartFreeShippingHeading +
      'Orders placed now <strong class="custom-buy-box__delivery-countdown">ship the next business day.</strong>';
  } else {
    message.innerHTML =
      cartFreeShippingHeading +
      'Orders placed now <strong class="custom-buy-box__delivery-countdown">ship the next business day.</strong>';
  }

  return;
}

    const cutoff = getCutoffForDate(new Date(), popover);
    const [hour, minute] = cutoff.split(':').map(Number);

    const now = new Date();
    const cutoffDate = new Date();
    cutoffDate.setHours(hour, minute || 0, 0, 0);

    const diff = cutoffDate - now;
    const hours = Math.floor(diff / 1000 / 60 / 60);
    const minutes = Math.floor((diff / 1000 / 60) % 60);

    const countdownParts = [];

    if (hours > 0) {
      countdownParts.push(`${hours} ${hours === 1 ? 'hr' : 'hrs'}`);
    }

    if (minutes > 0) {
      countdownParts.push(`${minutes} ${minutes === 1 ? 'min' : 'mins'}`);
    }

    const countdownText = countdownParts.join(' ');

    if (clockIcon) clockIcon.hidden = false;
    if (truckIcon) truckIcon.hidden = true;

    message.innerHTML =
      cartFreeShippingHeading +
      `Order within <span class="custom-buy-box__delivery-countdown">${countdownText}</span> for same-day shipping.`;
    });
 }

  document.addEventListener('click', function (event) {
    const clickedInsidePopover = event.target.closest('[data-delivery-popover]');
    const clickedToggle = event.target.closest('[data-delivery-panel-toggle]');

    if (!clickedInsidePopover && !clickedToggle) {
      document.querySelectorAll('[data-delivery-popover].is-open')
        .forEach(popover => {
          popover.classList.remove('is-open');
        });
    }

    const closeButton = event.target.closest('[data-delivery-popover-close]');

    if (closeButton) {
      const popover = closeButton.closest('[data-delivery-popover]');
      if (popover) popover.classList.remove('is-open');
      return;
    }

    const zipButton = event.target.closest('[data-delivery-zip-check]');

    if (zipButton) {
      event.preventDefault();

      const popover = zipButton.closest('[data-delivery-popover]');
      const zipInput = popover?.querySelector('[data-delivery-zip]');
      const stateSelect = popover?.querySelector('[data-delivery-state]');
      const state = zipToState(zipInput?.value);

      if (stateSelect && state) {
        stateSelect.value = state;
      }

      estimateByState(popover, state);
      return;
    }

    const toggleButton = event.target.closest('[data-delivery-panel-toggle]');

    if (toggleButton) {
      event.preventDefault();

      const deliveryContainer = toggleButton.closest(
        '.custom-buy-box, .mkcustom-mobile-buy-box, .mkcustom-cart-delivery'
      );

      const popover = deliveryContainer?.querySelector(
        '[data-delivery-popover]'
      );

      if (!popover) return;

      popover.classList.toggle('is-open');
    }
  });

  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-delivery-state]');
    if (!select) return;

    const popover = select.closest('[data-delivery-popover]');
    if (!popover) return;

    estimateByState(popover, select.value);
  });

  document.addEventListener('keydown', function (event) {
    const zipInput = event.target.closest('[data-delivery-zip]');
    if (!zipInput || event.key !== 'Enter') return;

    event.preventDefault();

    const popover = zipInput.closest('[data-delivery-popover]');
    const state = zipToState(zipInput.value);
    const stateSelect = popover?.querySelector('[data-delivery-state]');

    if (stateSelect && state) {
      stateSelect.value = state;
    }

    estimateByState(popover, state);
  });
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('[data-delivery-popover].is-open')
      .forEach(popover => {
        popover.classList.remove('is-open');
      });
  }
});
updateCountdown();

setInterval(updateCountdown, 60000);


/* Re-run when Shopify reloads a theme section */
document.addEventListener(
  'shopify:section:load',
  function () {
    updateCountdown();
  }
);


/* Re-run after cart quantity / remove updates */
document.addEventListener(
  'on:line-item:change',
  function () {
    window.requestAnimationFrame(function () {
      updateCountdown();
    });
  }
);


})();